import { render } from "./trainingParticipantForm.vue?vue&type=template&id=bb4cc9aa&ts=true"
import script from "./trainingParticipantForm.vue?vue&type=script&lang=ts"
export * from "./trainingParticipantForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__